import React from "react";
import HomeHero from "../components/HomeHero";
import OurServicesSection from "../components/OurServicesSection";
import StatsSection from "../components/StatsSection";
import WhyChooseUsSection from "../components/WhyChooseUsSection";
// import TestimonialSection from "../components/TestimonialSection";
import AnyQuestionsSection from "../components/AnyQuestionsSection";
import FooterSection from "../components/FooterSection";
import NavBar from "../components/NavBar";
import {
  Industries,
  PlatformList,
  Process,
} from "../components/ServiceSections";
import data from "../data.json";

const Home = () => {
  const { homeContent } = data;

  return (
    <div className="flex flex-col min-h-screen">
      <NavBar />
      <main className="flex-grow">
        <section id="home">
          <HomeHero />
        </section>
        <section id="platforms">
          <PlatformList
            tools={homeContent.platforms}
            title="Platforms We Work With"
          />
        </section>
        <section id="ourServices">
          <OurServicesSection />
        </section>
        <section id="stats">
          <StatsSection />
        </section>
        <section id="industries">
          <Industries
            industries={homeContent.industries}
            description="We understand the operating realities and regulatory requirements of the industries we serve."
          />
        </section>
        <section id="howWeWork">
          <Process
            steps={homeContent.process}
            title="How We Work"
            description="One team takes your project from the first study through energization and beyond."
          />
        </section>
        <section id="whyChooseUs">
          <WhyChooseUsSection />
        </section>
        {/* <section id="testimonials">
          <TestimonialSection />
        </section> */}
        <section id="anyQuestions">
          <AnyQuestionsSection />
        </section>
      </main>
      <FooterSection />
    </div>
  );
};
export default Home;
